import APIClient from '@/shared/http/clients/api'

const resourceName = 'DespesaDescontoLote'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetByName = (name, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetByName/${name}`, data, config)
const GetByCode = (name, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetByCode/${name}`, data, config)
const GetAll = (name, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetAll`, data, config)

const LotDiscountExpenseRepository = {
  GetByName,
  GetByCode,
  GetAll
}
export default LotDiscountExpenseRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/lotdiscountexpense.js